import { URLS } from 'config';
import { useJobContext } from 'pages/Job/context';
import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';

export interface JobMakeChangesButtonHook {
  show: boolean;
  url: string;
}

export default function useJobMakeChangesButton(): JobMakeChangesButtonHook {
  const { id, changesRequested } = useJobContext();

  const show = useMemo(() => changesRequested, [changesRequested]);

  const url = useMemo(() => generatePath(URLS.modifyJob, { id }), [id]);

  return {
    show,
    url,
  };
}
